import styled from 'styled-components';

import { Card } from '@xingternal/card';
import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { spaceS, spaceXL, spaceXXL } from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

import { JobPostingModule } from '@/components/job-posting-module';

export const ModuleTitle = styled(Headline)`
  margin-bottom: ${spaceXL};
  margin-top: ${spaceXL};
  @media ${mediaWide} {
    margin-bottom: ${spaceXXL};
  }
`;

export const StyledJobPostingModule = styled(JobPostingModule)`
  flex-direction: column;
`;

export const AboutCompanyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${mediaWide} {
    flex-direction: row;
    gap: ${spaceXL};
  }
`;

export const CompanyModuleWrapper = styled.div`
  justify-content: center;

  @media ${mediaWide} {
    flex: 2;

    .employer-company {
      /* override normal padding when shown side by side with HR contact */
      padding: ${spaceXL};
    }
  }
`;

export const HRContactWrapper = styled.div`
  justify-content: center;
  flex: 1;

  @media ${mediaWide} {
    .employer-hr-contact {
      /* override normal padding when shown side by side with company module */
      padding: ${spaceXL};
    }
  }
`;
export const CompanyModuleStyled = styled(Card)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: ${spaceXL};
  justify-content: center;

  /* ProfileInfo already has 16px top/bottom padding in this case */
  @media ${mediaConfined} {
    padding: ${spaceS} ${spaceXL};
  }
`;
